module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"iroType":{"POSITIVE_IMPACT":"Positive Impact","NEGATIVE_IMPACT":"Negative Impact","RISK":"Risk","OPPORTUNITY":"Opportunity"}},"de":{"iroType":{"POSITIVE_IMPACT":"Positive Auswirkung","NEGATIVE_IMPACT":"Negative Auswirkung","RISK":"Risiko","OPPORTUNITY":"Chancen"}}}')
  delete Component.options._Ctor
}
